import { Grid, Typography, useMediaQuery, useTheme } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { CLOUDINARY_NAME } from '../../constants'
import { Image } from 'cloudinary-react'
import React, {useState} from 'react'
import { ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles'
import baseSiteTheme from '../Base/baseSiteTheme'
import ArrowBackRoundedIcon from '@material-ui/icons/ArrowBackRounded'
import { useHistory } from 'react-router-dom'
import SynthesiaVideoModal from './SynthesiaVideoModal';

const useStyles = makeStyles((theme) => ({
    container: {
        [theme.breakpoints.up('lg')]: {
            paddingTop: '5rem',
        },
    },
    text: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        padding: '1rem 1rem 0.5rem 1rem',
    },
    h1: {
        margin: '10px 0!important',
        maxWidth: '35rem',
        [theme.breakpoints.up('lg')]: {
            width: '20rem',
        },
    },
    p: {
        [theme.breakpoints.up('lg')]: {
            width: '28rem',
        },
    },
    img: {
        marginTop: 10,
        [theme.breakpoints.up('md')]: {
            marginTop: 10,
        },
    },
    back: {
        display: 'flex',
        alignItems: 'center',
        color: '#797979',
        fontWeight: '600',
        cursor: 'pointer',
    },
    backIcon: {
        fontSize: '1.2rem',
        marginRight: '5px',
    },
}))
const OpenLoopCardErrorPage = () => {
    const classes = useStyles()
    const history = useHistory()
    const theme = useTheme()

    const [modalWithVideoIsOpen, setModalWithVideoIsOpen] = useState(true)

    const isMobile = useMediaQuery(theme.breakpoints.down('md'), {
        defaultMatches: true,
    })
    const goBack = () => {
        history.goBack()
    }
    return (
        <MuiThemeProvider theme={baseSiteTheme}>
            <SynthesiaVideoModal
                modalIsOpen={modalWithVideoIsOpen}
                closeModal={() => {
                    setModalWithVideoIsOpen(false)
                }}
            />
            <Grid container className={classes.container} justify={'center'}>
                <Grid item lg={6}>
                    <div className={classes.text}>
                        <div>
                            <span onClick={goBack} className={classes.back}>
                                <ArrowBackRoundedIcon
                                    className={classes.backIcon}
                                />{' '}
                                <p>Back</p>
                            </span>
                            <h1 className={classes.h1}>
                                This doesn’t appear to be our card.
                            </h1>
                            <Typography className={classes.p}>
                                Please check the back of your card and look for
                                the Gift Card Granny logo shown in the image. If
                                you do not see the Gift Card Granny logo, please
                                look for the name of the company that issued you
                                the card and contact them.
                            </Typography>
                            <br/>
                            <a href="#" onClick={() => setModalWithVideoIsOpen(true)}>Watch Synthesia video</a>
                        </div>
                    </div>
                </Grid>
                <Grid item lg={6}>
                    <Image
                        cloudName={CLOUDINARY_NAME}
                        className={classes.img}
                        publicId={'GCG/assets/card-back_rhqmju'}
                        loading="lazy"
                        title={`Gift Card Granny back of card`}
                        alt={`Gift Card Granny back of card`}
                        width={isMobile ? '350' : '584'}
                        height={isMobile ? '221' : '369'}
                    ></Image>
                </Grid>
            </Grid>
        </MuiThemeProvider>
    )
}

export default OpenLoopCardErrorPage
